import { managerCommissions } from './api'
import { takeLatestApiCall } from 'syft-acp-core/sagas/helpers'

import types from './action-types'

export default function* saga() {
  yield takeLatestApiCall(types.ENTITIES_FETCH_BEGIN, managerCommissions)
}
